import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Solutions from './components/Solutions';
import Calculator from './components/Calculator';
import WhyUs from './components/WhyUs';
import CTA from './components/CTA';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Problems />
      <Solutions />
      <Calculator />
      <WhyUs />
      <CTA />
      <Footer />

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#0066ff] to-[#5b4cff] text-white rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110 z-50 cursor-pointer"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </div>
  );
}